<template>
  <section class="login-container">
    <p>ログインに使用するメールアドレスを入力してください。<br>入力したメールアドレス宛にパスワード再設定用のリンクを送信します。</p>

    <div class="input-container">
      <form @submit.prevent="submit">
        <input type="text" v-model="req.email" name="email" id="email" placeholder="ログイン用のメールアドレスを入力">
        <button type="submit" class="btn success" v-if="!isLoading">メール送信</button>
        <template v-if="isLoading">
          <loading :message="'送信中...'"></loading>
        </template>
      </form>
      <button class="btn cancel" @click="$router.back()" v-if="!isLoading">戻る</button>
    </div>
  </section>
</template>
  
<script lang="ts">
import { UserApi } from "@/api/UserApi";
import Message from "@/const/Message";
import { DialogService } from "@/service/DialogService";
import { PasswordForgotReq, PasswordForgotRes } from "@/types/User";
import { defineComponent, Ref, ref } from "vue";
export default defineComponent({
  setup() {

    const req: Ref<PasswordForgotReq> = ref({
      email: '',
    });

    const isLoading = ref(false);

    const submit = async () => {
      isLoading.value = true;
      const api = new UserApi();
      let res: PasswordForgotRes | null = null;
      try {
        res = await api.forgotPassword(req.value);
        if (!res.result) {
          DialogService.error({
            title: Message.ERROR_MAIL_SEND,
            text: 'しばらく経ってから再度送信してください',
          })
          return
        }

        DialogService.success({
          title: Message.SUCCESS_MAIL_SEND,
          text: 'メールを確認してパスワードのリセットを行ってください。この画面は閉じて構いません。',
        })
      } catch (error) {
        DialogService.error({
          text: Message.ERROR_MAIL_SEND,
        })
      } finally {
        isLoading.value = false;
      }
    }

    return {
      req,
      submit,
      isLoading
    };
  },
  components: {
  },
});
</script>
  
<style lang="scss" scoped>
@import '@scss/pages/login.scss';
</style>